(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["motors-vehicle-confirmation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('motors-vehicle-confirmation')) {
    customElements.define('motors-vehicle-confirmation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.rules = (this.dataset.rules || '').split(';').filter(Boolean).map(row => {
          const [make, model, years] = row.split('|');
          return {make, model, years: (years || '').split(',')};
        });
        this.year = this.querySelector('[name="properties[Vehicle year]"]');
        this.warning = this.querySelector('[data-vehicle-error]');
        this.fitment = this.querySelector('[name="properties[Fitment status]"]');
        this.make = this.querySelector('[data-vehicle-make]');
        this.model = this.querySelector('[data-vehicle-model]');
        this.modelOptions = this.querySelector('[data-vehicle-model-options]');
        this.updateModels(true);
        this.make.addEventListener('change', () => this.updateModels(false));
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-vehicle-confirmation]')) {
            this.querySelector('[data-vehicle-confirmation]').checked = false;
          }
          this.validateSelection();
        });
        this.addEventListener('input', (event) => {
          if (!event.target.matches('[data-vehicle-confirmation]')) {
            this.querySelector('[data-vehicle-confirmation]').checked = false;
          }
          this.validateSelection();
        });
        this.validateSelection();
        const form = this.closest('form');
        form?.querySelector('[name="id"]')?.addEventListener('change', () => {
          this.querySelector('[data-vehicle-confirmation]').checked = false;
        });
      }

      validateSelection() {
        const available = this.rules.length > 0;
        const makeRows = this.rules.filter(row => row.make === this.make.value);
        const modelRows = makeRows.filter(row => row.model === this.model.value);
        const wrongMake = this.make.value !== '' && makeRows.length === 0;
        const wrongModel = this.make.value !== '' && this.model.value !== '' && modelRows.length === 0;
        const candidates = this.model.value && this.make.value ? modelRows : this.make.value ? makeRows : this.rules;
        const wrongYear = this.year.value !== '' && !candidates.some(row => row.years.includes(this.year.value));
        const mismatch = wrongMake || wrongModel || wrongYear;
        const message = available ? this.dataset.mismatch : this.dataset.review;
        this.year.setCustomValidity(!available || wrongYear ? message : '');
        this.make.setCustomValidity(wrongMake ? message : '');
        this.model.setCustomValidity(wrongModel ? message : '');
        for (const field of [this.year, this.make, this.model]) {
          field.setAttribute('aria-invalid', String(field.validity.customError));
          if (field.validity.customError) field.setAttribute('aria-errormessage', this.warning.id);
          else field.removeAttribute('aria-errormessage');
        }
        this.warning.textContent = available && mismatch ? message : '';
        this.warning.hidden = !available || !mismatch;
        const complete = this.year.value !== '' && this.make.value !== '' && this.model.value !== '';
        const matches = available && complete && !mismatch;
        this.fitment.value = matches ? this.dataset.matched : 'Not verified';
        return matches;
      }

      updateModels(preserve) {
        const previous = preserve ? this.model.value : '';
        const placeholder = this.make.value ? this.model.dataset.chooseModel : this.model.dataset.chooseMakeFirst;
        this.model.replaceChildren(new Option(placeholder, ''));
        for (const option of this.modelOptions.content.querySelectorAll('option')) {
          if (option.dataset.make === this.make.value) this.model.append(option.cloneNode(true));
        }
        this.model.value = previous;
        if (this.model.selectedIndex < 0) this.model.selectedIndex = 0;
        if (!preserve) this.querySelector('[data-vehicle-confirmation]').checked = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
